import LegalPage from "../../components/LegalPage";

export default function Cookies() {
  return (
    <LegalPage
      badge="Legal"
      title="Cookies Policy"
      lastUpdated="Feb 1, 2026"
      sections={[
        {
          heading: "What Are Cookies?",
          paragraphs: [
            "Cookies are small text files placed on your device when you visit a website. They allow the site to recognize your device and remember information about your visit, like your preferences and login state.",
            "Brivo uses cookies and similar technologies (pixels, local storage) to operate, secure, and improve our services.",
          ],
        },
        {
          heading: "Categories of Cookies We Use",
          paragraphs: [],
          bullets: [
            "Strictly necessary: required for core functionality such as login, security, and load balancing. These cannot be disabled.",
            "Performance & analytics: help us understand how you use the Service so we can improve it (e.g., PostHog, Segment).",
            "Functional: remember your preferences (e.g., language, dashboard layout).",
            "Marketing: used to deliver relevant ads and measure campaign effectiveness on third-party platforms.",
          ],
        },
        {
          heading: "Managing Your Cookie Preferences",
          paragraphs: ["You can manage cookies through your browser settings — block all, accept all, or be prompted before cookies are set. You can also use our in-app Cookie Preferences panel to opt in or out of non-essential cookies at any time."],
        },
        {
          heading: "Third-Party Cookies",
          paragraphs: ["Some of our pages embed content (e.g., YouTube videos, Stripe checkout) that set their own cookies. These third parties have their own privacy policies, which we encourage you to read."],
        },
        {
          heading: "Do Not Track",
          paragraphs: ["We respect 'Do Not Track' signals where required by law. When DNT is enabled, we disable analytics and marketing cookies for your session."],
        },
        {
          heading: "How Long Cookies Last",
          paragraphs: ["Session cookies expire when you close your browser. Persistent cookies remain for the duration specified at creation — typically 30 days to 2 years, depending on purpose."],
        },
        {
          heading: "Changes to This Policy",
          paragraphs: ["If we change which cookies we use or how we use them, we'll update this page and (if material) notify you in-app. The 'Last updated' date at the top reflects the latest revision."],
        },
        {
          heading: "Contact",
          paragraphs: ["Questions about cookies? Email privacy@brivo.app."],
        },
      ]}
    />
  );
}
